import { render, staticRenderFns } from "./appTemplate.vue?vue&type=template&id=2d7e3084&scoped=true"
import script from "./appTemplate.vue?vue&type=script&lang=js"
export * from "./appTemplate.vue?vue&type=script&lang=js"
import style0 from "./appTemplate.vue?vue&type=style&index=0&id=2d7e3084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7e3084",
  null
  
)

export default component.exports